(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voidlook-scroll-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.VoidlookScrollTextSystemV2) {
    window.VoidlookScrollTextSystemV2.initAll(document);
    return;
  }

  var states = new WeakMap();

  function modulo(value, size) {
    return ((value % size) + size) % size;
  }

  function initSection(section) {
    if (!section || states.has(section)) return;

    var track = section.querySelector('.vl-scroll-track');
    var groups = Array.prototype.slice.call(
      section.querySelectorAll('.vl-scroll-group')
    );

    if (!track || groups.length < 3) return;

    var referenceGroup = groups[1];
    var baseHTML = referenceGroup.innerHTML;
    var groupWidth = 0;
    var frame = null;

    function ensureGroupWidth() {
      var viewportWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        1440;

      var minimumWidth = Math.max(viewportWidth * 1.75, 1800);
      var safety = 0;

      while (
        referenceGroup.scrollWidth < minimumWidth &&
        safety < 8
      ) {
        groups.forEach(function (group) {
          group.insertAdjacentHTML('beforeend', baseHTML);
        });

        safety += 1;
      }

      groupWidth = referenceGroup.getBoundingClientRect().width;
      requestRender();
    }

    function render() {
      frame = null;

      if (!groupWidth) {
        groupWidth = referenceGroup.getBoundingClientRect().width;
      }

      if (!groupWidth) return;

      var rect = section.getBoundingClientRect();

      var viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight;

      var progress = viewportHeight - rect.top;

      var speed =
        (parseFloat(section.dataset.speed) || 140) / 100;

      var direction =
        section.dataset.direction || 'left';

      var phase = modulo(
        progress * speed,
        groupWidth
      );

      var x;

      if (direction === 'right') {
        x = -groupWidth + phase;
      } else {
        x = -groupWidth - phase;
      }

      track.style.transform =
        'translate3d(' + x + 'px, 0, 0)';
    }

    function requestRender() {
      if (frame !== null) return;

      frame = window.requestAnimationFrame(render);
    }

    function onResize() {
      groupWidth = referenceGroup.getBoundingClientRect().width;
      ensureGroupWidth();
    }

    window.addEventListener(
      'scroll',
      requestRender,
      { passive: true }
    );

    document.addEventListener(
      'scroll',
      requestRender,
      true
    );

    window.addEventListener(
      'resize',
      onResize
    );

    var resizeObserver = null;

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function () {
        groupWidth = referenceGroup.getBoundingClientRect().width;
        requestRender();
      });

      resizeObserver.observe(referenceGroup);
    }

    states.set(section, {
      render: requestRender,
      resize: onResize,
      resizeObserver: resizeObserver,
      getFrame: function () {
        return frame;
      }
    });

    ensureGroupWidth();
  }

  function destroySection(section) {
    var state = states.get(section);

    if (!state) return;

    window.removeEventListener(
      'scroll',
      state.render
    );

    document.removeEventListener(
      'scroll',
      state.render,
      true
    );

    window.removeEventListener(
      'resize',
      state.resize
    );

    if (state.resizeObserver) {
      state.resizeObserver.disconnect();
    }

    var currentFrame = state.getFrame();

    if (currentFrame !== null) {
      window.cancelAnimationFrame(currentFrame);
    }

    states.delete(section);
  }

  function initAll(root) {
    root = root || document;

    if (
      root.matches &&
      root.matches('[data-voidlook-scroll]')
    ) {
      initSection(root);
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll('[data-voidlook-scroll]')
        .forEach(initSection);
    }
  }

  window.VoidlookScrollTextSystemV2 = {
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      },
      { once: true }
    );
  } else {
    initAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      if (
        event.target &&
        event.target.matches &&
        event.target.matches('[data-voidlook-scroll]')
      ) {
        destroySection(event.target);
      }

      if (
        event.target &&
        event.target.querySelectorAll
      ) {
        event.target
          .querySelectorAll('[data-voidlook-scroll]')
          .forEach(destroySection);
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();
})();
